import {Dashboard} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getDashboard(context, pagination) {
        return Dashboard.getDashboard(pagination).then((response) => {
            return response.data;
        });
    },
    getDashboardRanking(context, pagination) {
        return Dashboard.getDashboardRanking(pagination).then((response) => {
            return response.data;
        });
    },
    updateImagesDashboard(context, pagination) {
        return Dashboard.updateImagesDashboard(pagination).then((response) => {
            return response.data;
        });
    },
    updateDashboardConfig(context, pagination) {
        return Dashboard.updateDashboardConfig(pagination).then((response) => {
            return response.data;
        });
    },
    updateCompanyGoalAnnouncement(context, pagination) {
        return Dashboard.updateCompanyGoalAnnouncement(pagination).then((response) => {
            return response.data;
        });
    }
};

const module = {
    state,
    mutations,
    actions
};

export default module;
